import { Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { Helmet } from 'react-helmet-async'

import Layout from '@components/Layout'
import LoadingSpinner from '@components/ui/LoadingSpinner'
import ErrorBoundary from '@components/ErrorBoundary'

// Lazy load pages for better performance
const Home = lazy(() => import('@pages/Home'))
const About = lazy(() => import('@pages/About'))
const Contact = lazy(() => import('@pages/Contact'))
const NotFound = lazy(() => import('@pages/NotFound'))

function App() {
  return (
    <>
      <Helmet>
        <title>Julián Mora - Ingeniero XR & IA | Portafolio Personal</title>
        <meta name="description" content="Portafolio de Julián Camilo Mora Valbuena - Ingeniero de Software especializado en Realidad Virtual, Realidad Aumentada e Inteligencia Artificial." />
        <meta name="keywords" content="Julián Mora, XR Developer, VR, AR, Unity, Meta Quest, HoloLens, Apple Vision Pro, Inteligencia Artificial, LLM" />
        <meta name="author" content="Julián Camilo Mora Valbuena" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Julián Mora - Ingeniero XR & IA" />
        <meta property="og:description" content="Portafolio de Julián Camilo Mora Valbuena - Especialista en desarrollo de experiencias inmersivas y aplicaciones de IA." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://julianmora.dev" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Julián Mora - Ingeniero XR & IA" />
        <meta name="twitter:description" content="Portafolio de Julián Camilo Mora Valbuena - Especialista en desarrollo de experiencias inmersivas y aplicaciones de IA." />
        
        {/* Theme */}
        <meta name="theme-color" content="#8b5cf6" />
        <meta name="msapplication-TileColor" content="#8b5cf6" />
      </Helmet>

      <ErrorBoundary>
        <Layout>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </ErrorBoundary>
    </>
  )
}

export default App 